import HttpClient from '../httpClient';
import UsersService from './usersService';
import Comment from '../models/comment';

const CommentsService = {

  parseComment: function(response) {
    if (!response) return null;

    return {
      id: response.id,
      createdAt: new Date(response.created_at),
      text: response.body,
      user: UsersService.parseUser(response._embedded['dm:user:v1']),
      _links: response._links,
      _forms: response._forms
    };
  },

  createComment(entry, newCommentText) {
    const commentParams = { body: newCommentText };
    const createCommentForm = entry.getForm('dm:create_comment:v1');

    return HttpClient[createCommentForm.method](createCommentForm.href, { comment: commentParams }).then(response => {
      const commentProps = CommentsService.parseComment(response);
      return new Comment(commentProps);
    });
  }

};

export default CommentsService;



// WEBPACK FOOTER //
// ./src/api/services/commentsService.js